import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FlugsComponent } from './flugs.component';

const routes: Routes = [
    {
        path: '',
        component: FlugsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FlugsRoutingModule { }
